import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { List } from "immutable";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserToken } from "../../../../../../auth/user-token.model";
import { MessagingService } from "../../../../../../core/messaging/messaging.service";
import { SeverityType } from "../../../../../../core/messaging/severity-type.enum";
import { UserService } from "../../../../../../core/user/user.service";
import { MenuItem } from "../../../../../../shared/menu/menu-item.model";
import { PopoverComponent } from "../../../../../../shared/panel/popover/popover.component";
import { ArrayHelper } from "../../../../../../utilities/contracts/array-helper";
import { ChaseSearchService } from "../../../../../api/chase-search/chase-search.service";
import { ChaseUnasssignModel } from "../../../../../api/unassign-chase/chase-unassign-model";
import { UnassignChaseService } from "../../../../../api/unassign-chase/unassign-chase.service";
import { RetrievalService } from "../../../../dashboard/retrieval/retrieval.service";
import { RetrievalCallFlowService } from "../../../retrieval-call-flow/retrieval-call-flow.service";
import { ContactRecord } from "../address-detail-contact-record";
import { AddressDetailEditService } from "../address-detail-edit/address-detail-edit.service";
import { AddressEditModel } from "../address-detail-edit/address-edit-model";
import { AddressDetailHeaderService } from "./address-detail-header.service";


@Component({
  selector: "retrieval-address-detail-header",
  templateUrl: "./address-detail-header.component.html",
  styleUrls: ["./address-detail-header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressDetailHeaderComponent implements OnInit, OnDestroy {
  @ViewChild("callPopOver", { static: true }) callPopOver: PopoverComponent;
  private unsubscribe = new Subject();
  addressId: number;
  user: UserToken;
  @Input() display = false;
  backButtonText = "Go Back";
  addressLocationText: string;
  iconName = "chevron-down";
  iconPos = "right";
  isAddressEditView = false;
  isAddressAssignmentView = false;
  isEmrAssignmentView = false;
  isFTAssignmentView = false;
  assignmentItems: any[];
  addressEditModel: AddressEditModel;
  private twilioApiUrl;
  subMenuItemsAsArray: MenuItem[];
  isFinishCall = false;
  chaseList: number[];
  // private twilioApiUrl = "http://localhost:62395/api/call/view";

  phoneNumber: string;
  menuItems = List<MenuItem>();
  twilioWidth = 220;
  twilioHeight = 310;
  private contactMethodPhone = 1;
  private actionSource = "TwilioDisconnect";
  assignedTo: number;
  private documentRetrievalLead = 4;

  constructor(
    private service: AddressDetailHeaderService,
    private callService: RetrievalCallFlowService,
    private userService: UserService,
    private addressDetailservice: AddressDetailEditService,
    private retrievalService: RetrievalService,
    private chaseService: ChaseSearchService,
    private chaseUnassignService: UnassignChaseService,
    private messagingService: MessagingService,
    private changeDetector: ChangeDetectorRef,
    private router: Router,
    private readonly route: ActivatedRoute
  ) {

    this.addressId = this.service.getAddressGdFromPath();
    this.user = this.userService.getUserToken();
    this.assignedTo = (this.user.functionalRoleIds.indexOf(this.documentRetrievalLead) > -1) ? null : this.user.userId;
  }

  ngOnInit() {

    this.route.paramMap.subscribe(params => {
      this.addressId = +params.get("AddressGd");

      this.isFinishCall = false;

      this.service
        .getMenuItems()
        .subscribe(this.assignAndNotifyMenuItems);

      this.addressDetailservice
        .getAddressDetailsForEdit()
        .subscribe(this.assignAndNotify);

      this.assignmentItems = [
        {
          label: "To PSR", command: () => {
            this.showAddressAssignmentModal();
          },
        },
        {
          label: "To Field Tech", command: () => {
            this.showFTAssignmentModal();
          },
        },
        {
          label: "To EMR", command: () => {
            this.showEmrAssignmentModal();
          },
        },
      ];

    });

    this.service.reset
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(id => this.updateAddressHeader(id));

    this.service.resetHeaderMenu
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(tabVisible => this.updateHeaderMenu(tabVisible));

    this.chaseService.chaseIdsList
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(item => this.chaseList = item);

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  updateAddressHeader(id) {
    this.addressDetailservice
      .getAddressDetailsForEdit()
      .subscribe(this.assignAndNotify);

  }

  updateHeaderMenu(callTabVisible: boolean) {
    if (!ArrayHelper.isAvailable(this.subMenuItemsAsArray)) {
      setTimeout(() => {
        this.updateHeaderMenu(callTabVisible);
      },         50);
      return;
    }

    this.subMenuItemsAsArray.find(item => item.description === "Address Call").show = callTabVisible;
    if (callTabVisible === false) {
      this.isFinishCall = true;
    }
    this.assignAndNotifyMenuItems(this.subMenuItemsAsArray);
  }

  private assignAndNotify = (data: AddressEditModel): void => {

    this.changeDetector.markForCheck();

    this.addressEditModel = new AddressEditModel(data);

    this.addressLocationText = `${this.addressEditModel.address1} ${this.addressEditModel.address2}, ${this.addressEditModel.addressCity},
                                ${this.addressEditModel.addressState} ${this.addressEditModel.addressZip}`;

    this.phoneNumber = this.addressEditModel.phone;
    // this.phoneNumber = "3476197023";
  }

  get addressText() {
    return `Address Id ${this.addressId}`;
  }

  get twiliourl() {

    const contactRecordObject =
      new ContactRecord({
        addressId: this.addressId,
        assignedTo: this.assignedTo,
        organizationId: this.user.organizationId,
        callerUserId: this.user.userId,
        contactResultType: null,
        contactMethodType: this.contactMethodPhone,
        contactNumber: this.phoneNumber,
      });

    const contactRecord = JSON.stringify(contactRecordObject);

    return `${this.twilioApiUrl}?contactRecord=${contactRecord}`;

  }

  private assignAndNotifyMenuItems = (data: MenuItem[]): void => {
    const calltype = this.service.getCallTypeFromPath();
    const menuItems = data.map(item => {
      if (item.description === "Address Call" && item.path.indexOf("incoming") < 0 && item.path.indexOf("outgoing") < 0) {

        const path = `${item.path}/${calltype}`;
        return new MenuItem({ ...item, path } as any);
      } else {
        return item;
      }
    });

    this.subMenuItemsAsArray = menuItems;
    this.menuItems = List(menuItems);

    this.changeDetector.markForCheck();
  }

  showCallPopover(event) {
    this.updateHeaderMenu(true);
    const calltype = "outgoing";
    this.router.navigateByUrl(`retrieval/addressdetail/${this.addressId}/call/${calltype}`);
    this.display = true;
    this.callPopOver.show(event);
  }

  hideCallPopOver() {
    this.display = false;
    this.callPopOver.hide();
    this.changeDetector.markForCheck();
  }

  endCallOnHangup() {

    this.hideCallPopOver();

    const contactRecord =
      new ContactRecord({ addressId: this.addressId, organizationId: this.user.organizationId, contactResultType: null, contactMethodType: this.contactMethodPhone, contactNumber: null });


    this.callService
      .saveCallResult(contactRecord, this.actionSource)
      .subscribe();
  }

  getNextAddress(): void {
    const retrievalRolePSR = 1;

    this.unAssignChasesAtAddressLocation();
    this.retrievalService.getNextAddressId(retrievalRolePSR)
      .subscribe((AddressId: number) => {
        if (AddressId !== 0 && AddressId !== null) {
          this.router.navigateByUrl(`retrieval/addressdetail/${AddressId}`);
          this.changeDetector.markForCheck();
        } else {
          this.messagingService.showToast("No Additional Work found to Assign.", SeverityType.INFO);
          this.changeDetector.markForCheck();
        }
      });
  }

  private unAssignChasesAtAddressLocation(): void {
    const functionalRoleIdRetrieval = 5;
    const unasssignModel = new ChaseUnasssignModel({
      chaseList: this.chaseList,
      functionalRoleId: functionalRoleIdRetrieval,
      masterDocumentSourceId: this.addressId,
    });

    this.chaseUnassignService.unassignChases(unasssignModel).subscribe(
      data => {
        this.messagingService.showToast("Chases(s) have been unassigned.", SeverityType.SUCCESS);
      },
      err => {
        this.messagingService.showToast("Error while unassigning Chases(s).", SeverityType.ERROR);
      });

  }

  receiveAddressAssignmentValue($event) {
    this.isAddressAssignmentView = $event;
  }

  showAddressAssignmentModal() {
    this.isAddressAssignmentView = true;
  }

  receiveEmrAssignmentValue($event) {
    this.isEmrAssignmentView = $event;
  }

  showEmrAssignmentModal() {
    this.isEmrAssignmentView = true;
  }

  receiveFTAssignmentValue($event) {
    this.isFTAssignmentView = $event;
  }

  showFTAssignmentModal() {
    this.isFTAssignmentView = true;
  }

  receiveAddressEditValue($event) {
    this.isAddressEditView = $event;
  }

  showEditAddressModal() {
    this.isAddressEditView = true;
  }

  navigateNewDesign(): void {
    this.router.navigateByUrl(`retrieval/addressdetail/${this.addressId}`);
  }

}
